import React, { useEffect } from 'react';
import { Button, Modal, Table, Tag, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

// Config push has no download/verify/reboot phase (the config is embedded
// directly in the MQTT payload), so this state set is simpler than
// firmware's OTA states - see OtaStatusModal.js for that one.
const STATE_META = {
  PENDING: { color: 'default', label: 'Pending' },
  ACCEPTED: { color: 'blue', label: 'Accepted' },
  APPLIED: { color: 'green', label: 'Applied' },
  REJECTED: { color: 'red', label: 'Rejected' },
  FAILED: { color: 'red', label: 'Failed' },
  TIMEOUT: { color: 'red', label: 'Timed out (no response)' },
};

const PushStatusModal = (props) => {
  const { t } = useTranslation();
  const deviceConfig = props.deviceConfig;
  const status = props.pushStatus;

  useEffect(() => {
    if (props.visible && deviceConfig?.VERSION) {
      props.loadStatus(deviceConfig.VERSION);
    }
  }, [props.visible, deviceConfig?.VERSION]);

  const columns = [
    {
      key: 'MAC',
      title: t('DeviceConfigPage.pushStatusModal.mac'),
      dataIndex: 'MAC',
    },
    {
      key: 'STATE',
      title: t('DeviceConfigPage.pushStatusModal.state'),
      render: (_, row) => {
        const meta = STATE_META[row.STATE] || { color: 'default', label: row.STATE };
        const tag = <Tag color={meta.color}>{t(`DeviceConfigPage.pushStatusModal.states.${row.STATE}`, meta.label)}</Tag>;
        return row.DETAIL ? <Tooltip title={row.DETAIL}>{tag}</Tooltip> : tag;
      },
    },
    {
      key: 'UPDATED_TIME',
      title: t('DeviceConfigPage.pushStatusModal.updatedTime'),
      render: (_, row) => row.UPDATED_TIME || '-',
    },
  ];

  return (
    <Modal
      title={
        t('DeviceConfigPage.pushStatusModal.title') +
        (deviceConfig?.VERSION ? ` — ${deviceConfig.VERSION}` : '')
      }
      open={props.visible}
      onCancel={props.close}
      footer={
        <Button
          icon={<ReloadOutlined />}
          onClick={() => deviceConfig?.VERSION && props.loadStatus(deviceConfig.VERSION)}
        >
          {t('DeviceConfigPage.pushStatusModal.refresh')}
        </Button>
      }
    >
      {status?.RESULT && (
        <div style={{ marginBottom: 12 }}>
          <div>
            {t('DeviceConfigPage.pushStatusModal.summary', {
              confirmed: status.CONFIRMED_COUNT,
              total: status.TOTAL_COUNT,
            })}
          </div>
          {status.PUSHED_TIME && (
            <div style={{ color: '#888' }}>
              {t('DeviceConfigPage.pushStatusModal.pushedAt') + ` ${status.PUSHED_TIME}`}
            </div>
          )}
        </div>
      )}
      <Table
        dataSource={status?.DEVICES || []}
        columns={columns}
        rowKey={'MAC'}
        pagination={false}
        size="small"
      />
    </Modal>
  );
};

export default PushStatusModal;
